// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ro-z","slideIn":"So-z"};